import { Injectable, inject } from '@angular/core';

import { ModalService } from '~/app/shared/services/modal/modal.service';
import {
    ModalProfilePhotoComponent,
    ProfilePhotoModalData,
    ProfilePhotoResult,
} from '../modals/modal-profile-photo/modal-profile-photo.component';

@Injectable({
    providedIn: 'root',
})
export class ModalProfilePhotoService {
    private modal = inject(ModalService);

    public open(data: ProfilePhotoModalData) {
        return this.modal.open<ProfilePhotoResult, ProfilePhotoModalData>(ModalProfilePhotoComponent, data);
    }
}
